import * as Proxy from './Proxy'

export default (function () {
    const baseUrl = "/paymentlobby/api/Donations/";
    return {
        IsDonorValid(request) {
            var url = baseUrl + "IsValidDonor";
            return Proxy.Post(url, request);
        },
        ReturnToAmbitCares() {
            return Proxy.Redirect('https://int.ambitcares.org', 'https://ambitcares.org');
        }
    };
})()